module.exports = __webpack_public_path__ + "static/media/11.c3b9ed53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/11.jpg
// module id = 544
// module chunks = 0